import {Alert} from 'src/design/atoms/Alert';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {IconHistory} from '@tabler/icons-react';
import React from 'react';
import type {InspectionAuditEventResponse} from 'src/api/ProactApiClient';
import {formatUtcDateTime} from 'src/shared/utils/formatters';

export interface ReopenAuditBannerProps {
  events: InspectionAuditEventResponse[];
}

/** Banner listing reopen audit events (who/when/why). */
export const ReopenAuditBanner: React.FC<ReopenAuditBannerProps> = ({
  events,
}) => {
  if (events.length === 0) return null;

  return (
    <Alert
      color="yellow"
      icon={<IconHistory size={18} />}
      title="Re-opened history">
      <Stack gap={4}>
        {events.map((event, index) => (
          <Text key={index} size="sm">
            {event.creatorName ?? 'Unknown'}
            {event.createdAt ? ` — ${formatUtcDateTime(event.createdAt)}` : ''}
            {event.reason ? `: "${event.reason}"` : ''}
          </Text>
        ))}
      </Stack>
    </Alert>
  );
};
